const StickyTagsUpdatePopup = ({ updateValues, isDataLoading, valueToUpdate, setValuesToUpdate }) => {



  return <div className=" bg-slate-100/90 px-2 py-4 rounded lg:w-1/5 pt-20 w-full shrink-0">

    {valueToUpdate.tagValues ? <div className="text-xs mb-6 border-">
      <h3 className="text-2xl text-center">Tag Values</h3>
      {valueToUpdate.tagValues.map(cat => <div key={cat.category} className="my-4">
        <h4 className="pl-2 text-xl text-center font-semibold">{cat.category}</h4>
        <div>
          {
            cat.tags.map(tag => <div className="my-0.5" key={tag.tag}>
              <p className="font-semibold">{tag.tag}:</p><div className="pl-2">{tag.values.map((v, i) => <p key={v}>{i + 1}.{v}</p>)}</div>
            </div>)
          }
        </div>
      </div>)}

    </div> : null}

    {valueToUpdate.ASIN ? <div className="text-xs mb-6 border-">
      <h3 className="text-2xl text-center">ASIN values</h3>
      {valueToUpdate.ASIN.map(cat => <div key={cat.category} className="my-4">
        <h4 className="pl-2 text-xl text-center font-semibold">{cat.category}</h4>
        <div>
          {
            cat.values.map((asin, i) => <div className="my-0.5" key={asin.asinId}>
              <p className="font-semibold">{i + 1}. {asin.asinId} - {asin.link} {asin.delete ? ' - DELETE' : ''}</p>
            </div>)
          }
        </div>
      </div>)}

    </div> : null}

    <button className="px-2 py-1 bg-slate-700 active:bg-slate-900 disabled:bg-slate-400 rounded hover:bg-slate-800 text-white w-full disabled:italic" disabled={isDataLoading} onClick={updateValues}>Update Data</button>
  </div>
}

export default StickyTagsUpdatePopup
